export default __webpack_public_path__ + "static/media/hht2_ep3_speaking_03.cc8a1abe.png";